import TakeActionTooltip from './TakeActionTooltip';

export default TakeActionTooltip;
